import { render, staticRenderFns } from "./PageHeader.component.vue?vue&type=template&id=b7ad1090&"
import script from "./PageHeader.component.vue?vue&type=script&lang=ts&"
export * from "./PageHeader.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports